/**
 * SaveButton - Componente Presentacional
 * 
 * Componente que renderiza un botón de guardar con estado de carga.
 * Deshabilitado mientras se está guardando para evitar múltiples clics.
 * 
 * @component
 * @param {Object} props - Props del componente
 * @param {Function} props.onClick - Callback ejecutado al hacer click en el botón
 *   Se ejecuta solo si loading es false
 * @param {boolean} props.loading - Estado de carga del guardado
 *   Si es true: botón deshabilitado, texto "Guardando..."
 *   Si es false: botón habilitado, texto "Guardar"
 * @returns {JSX.Element} Contenedor con botón
 * 
 * Estilos:
 * - Botón rojo cuando está habilitado
 * - Botón gris cuando está deshabilitado (loading=true)
 * - Transición suave entre estados
 * - Animación de click (scale 0.98)
 * 
 * Comportamiento:
 * - Impide clicks múltiples durante el guardado
 * - Proporciona feedback visual del estado de carga
 * - Totalmente accesible (disabled attribute)
 */

export default function SaveButton({ onClick, loading }) {
  return (
    <div className='container-league-button'>
      <button
        onClick={onClick}
        className="league-save-button"
        disabled={loading}
      >
        {loading ? 'Guardando...' : 'Guardar'}
      </button>
    </div>
  );
}